// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pay-module__formBox--BDHg7 {
  flex-grow: 1;
  padding: 20px;
  border-radius: 16px;
  width: 80%;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
}

.Pay-module__titleBox--kkxub > h4 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-title);
}

.Pay-module__titleBox--kkxub > p {
  font-size: 14px;
  margin: 0;
}

.Pay-module__fieldBox--TM4hR {
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.Pay-module__btnBoxNext--YZsUV {
  display: flex;
  justify-content: space-between;
}

.Pay-module__colorBox--F79rI > p > span {
  font-weight: bold;
  color: var(--color-primary);
}

.Pay-module__colorBox--F79rI {
  margin: 20px 0;
  display: flex;
  gap: 10px;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: rgb(43 93 235 / 5%);
  border-radius: 20px;
  padding: 5px;
}

.Pay-module__colorBox--F79rI > p {
  margin: 0;
}

.Pay-module__icon--iKzC6 > svg {
  color: var(--color-primary);
  font-size: 25px;
}

.Pay-module__premium--L6OtJ {
  display: flex;
  justify-content: center;
}

.Pay-module__premium--L6OtJ > span {
  color: var(--color-primary);
  font-size: 25px;
  font-weight: bold;
}

.Pay-module__btnBox--RGXLX {
  display: flex;
  justify-content: space-between;
}
.Pay-module__btnBoxUpdate--l4lHh {
  display: flex;
  justify-content: end;
}

.Pay-module__successMessage--bd4bV {
  display: flex;
  flex-direction: column;
  color: green;
  font-size: 30px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.Pay-module__successMessage--bd4bV > p {
  color: green;
  font-size: 30px;
  font-weight: bold;
}

.Pay-module__successMessage--bd4bV > span > svg {
  color: green;
  font-size: 90px;
}

.Pay-module__fullWidthBox--U7sNI > div {
  width: 100%;
}

.Pay-module__FileItemBorder--oQAju {
  background-color: #e2e9ff;
  padding: 3px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px;
  border-radius: 14px;
}

.Pay-module__FileItem--Y5rXE {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px;
}

.Pay-module__FileItemBorder--oQAju > a,
.Pay-module__FileItem--Y5rXE > a {
  color: #6f879c;
  text-decoration: none;
}

.Pay-module__infoText--H4iRu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Pay-module__infoText--H4iRu > p {
  color: #4b5b69;
  font-size: 18px;
}

.Pay-module__btnDownload--VhapQ {
  display: flex;
}
.Pay-module__filesBox--PwxSx {
  display: flex;
  gap: 20px;
  justify-content: center;
}
.Pay-module__RewieBox--hjJfU {
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
}
.Pay-module__RewieBox--hjJfU p {
  color: var(--color-title);
  text-align: center;
}
.Pay-module__btnBoxRewie--gVZOQ {
  display: flex;
  justify-content: center;
}
.Pay-module__gradientButton--tFlLt {
  width: 100%;
  max-width: 200px;
  height: 40px;
  margin-bottom: 15px;
  margin-top: 20px;
  border-radius: 25px;
  background: linear-gradient(90deg, #0051df, #8da8ff);
  color: white !important;
  font-weight: 600;
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:active {
    transform: scale(0.98);
  }
}
@media (max-width: 950px) {
  .Pay-module__formBox--BDHg7 {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/cancer-protection/step-3/ui/Pay.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;EACpD,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,0BAA0B;;EAE1B;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".formBox {\r\n  flex-grow: 1;\r\n  padding: 20px;\r\n  border-radius: 16px;\r\n  width: 80%;\r\n  margin: 0px auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.titleBox > h4 {\r\n  margin: 0 0 20px 0;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: var(--color-title);\r\n}\r\n\r\n.titleBox > p {\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n.fieldBox {\r\n  display: flex;\r\n  gap: 20px;\r\n  flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.colorBox > p > span {\r\n  font-weight: bold;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.colorBox {\r\n  margin: 20px 0;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-content: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  border-radius: 20px;\r\n  padding: 5px;\r\n}\r\n\r\n.colorBox > p {\r\n  margin: 0;\r\n}\r\n\r\n.icon > svg {\r\n  color: var(--color-primary);\r\n  font-size: 25px;\r\n}\r\n\r\n.premium {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.premium > span {\r\n  color: var(--color-primary);\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n}\r\n\r\n.btnBox {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.btnBoxUpdate {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.successMessage {\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: green;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 50px;\r\n}\r\n\r\n.successMessage > p {\r\n  color: green;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n}\r\n\r\n.successMessage > span > svg {\r\n  color: green;\r\n  font-size: 90px;\r\n}\r\n\r\n.fullWidthBox > div {\r\n  width: 100%;\r\n}\r\n\r\n.FileItemBorder {\r\n  background-color: #e2e9ff;\r\n  padding: 3px 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 10px;\r\n  border-radius: 14px;\r\n}\r\n\r\n.FileItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 10px;\r\n}\r\n\r\n.FileItemBorder > a,\r\n.FileItem > a {\r\n  color: #6f879c;\r\n  text-decoration: none;\r\n}\r\n\r\n.infoText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.infoText > p {\r\n  color: #4b5b69;\r\n  font-size: 18px;\r\n}\r\n\r\n.btnDownload {\r\n  display: flex;\r\n}\r\n.filesBox {\r\n  display: flex;\r\n  gap: 20px;\r\n  justify-content: center;\r\n}\r\n.RewieBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  justify-content: center;\r\n  margin-top: 30px;\r\n}\r\n.RewieBox p {\r\n  color: var(--color-title);\r\n  text-align: center;\r\n}\r\n.btnBoxRewie {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.gradientButton {\r\n  width: 100%;\r\n  max-width: 200px;\r\n  height: 40px;\r\n  margin-bottom: 15px;\r\n  margin-top: 20px;\r\n  border-radius: 25px;\r\n  background: linear-gradient(90deg, #0051df, #8da8ff);\r\n  color: white !important;\r\n  font-weight: 600;\r\n  border: none;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s;\r\n\r\n  &:active {\r\n    transform: scale(0.98);\r\n  }\r\n}\r\n@media (max-width: 950px) {\r\n  .formBox {\r\n    width: 80%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `Pay-module__formBox--BDHg7`,
	"titleBox": `Pay-module__titleBox--kkxub`,
	"fieldBox": `Pay-module__fieldBox--TM4hR`,
	"btnBoxNext": `Pay-module__btnBoxNext--YZsUV`,
	"colorBox": `Pay-module__colorBox--F79rI`,
	"icon": `Pay-module__icon--iKzC6`,
	"premium": `Pay-module__premium--L6OtJ`,
	"btnBox": `Pay-module__btnBox--RGXLX`,
	"btnBoxUpdate": `Pay-module__btnBoxUpdate--l4lHh`,
	"successMessage": `Pay-module__successMessage--bd4bV`,
	"fullWidthBox": `Pay-module__fullWidthBox--U7sNI`,
	"FileItemBorder": `Pay-module__FileItemBorder--oQAju`,
	"FileItem": `Pay-module__FileItem--Y5rXE`,
	"infoText": `Pay-module__infoText--H4iRu`,
	"btnDownload": `Pay-module__btnDownload--VhapQ`,
	"filesBox": `Pay-module__filesBox--PwxSx`,
	"RewieBox": `Pay-module__RewieBox--hjJfU`,
	"btnBoxRewie": `Pay-module__btnBoxRewie--gVZOQ`,
	"gradientButton": `Pay-module__gradientButton--tFlLt`
};
export default ___CSS_LOADER_EXPORT___;
